'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      align-items: center;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../../styled');

var _theme = require('../../../styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _themes = require('../../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _helpers = require('../../../styled/helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var List = exports.List = (0, _styledComponents2.default)(_helpers2.default.ListReset)(_templateObject(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject2());
});